import { APPStatisticManager } from '../lib/statistics/app'
import { toString } from 'lodash'

const initialState = {
  id: null,
  email: '',
  password: '',
  isSubmitting: false,
  message: '',
  isSuccess: false,
  telephone: '',
  simple_telephone: '',
  first_name: '',
  style: {},
  subscription: {},
  shipping_address: {},
  isFreeUser: false,
  isFreeTote79: false,
  vacation_card: [],
  subscription_types: [],
  perfect_closet_stats: {},
  subscription_type: {},
  free_service: {},
  salesman: null
}

function reducer(state = initialState, action) {
  switch (action.type) {
    case 'ApiQueryMeSubscriptionPartialAction:SUCCESS': {
      if (!action.response.data) {
        return state
      }
      return {
        ...state,
        subscription: {
          ...state.subscription,
          ...action.response.data.me.subscription
        }
      }
    }
    case 'API:SUBSCRIPTION:HOLD:SUCCESS': {
      const { subscription } = action.response.data.HoldSubscription
      if (subscription) {
        return {
          ...state,
          subscription: { ...state.subscription, ...subscription }
        }
      }
      return state
    }
    case 'API:SUBSCRIPTION_QUERY:SUCCESS':
      return querySubscription(state, action)
    case 'API:CUSTOMER:UPDATE:SUCCESS':
      return {
        ...state
      }
    case 'API:CURRENT_CUSTOMER:SIGN_OUT:SUCCESS':
      return initialState
    case 'API:SUBSCRIPTION:QUERYCREATE:SUCCESS':
      const { data } = action.response
      return {
        ...state,
        ...data,
        message: action.response.message ? action.response.message[0] : '',
        isSubmitting: false,
        isSuccess: true,
        previousAction: 'create'
      }
    case 'API:SUBSCRIPTION:QUERYCREATE:ERROR':
      return {
        ...state,
        message: action.response.errors[0],
        isSubmitting: false
      }
    case 'API:FREESERVICE:SUCCESS':
      return {
        ...state,
        free_service: {
          ...state.free_service,
          ...action.response.data.me.free_service
        }
      }
    case 'API:FETCH:CURRENT:CUSTOMER:STARTED':
      return {
        ...state,
        isSubmitting: true
      }
    case 'API:FETCH:CURRENT:CUSTOMER:ERROR':
      return {
        ...state,
        message: action.response.message,
        isSubmitting: false
      }
    case 'API:FETCH:CURRENT:CUSTOMER:SUCCESS':
      return setCurrentCustomer(state, action)
    case 'CUSTOMER_PHOTO_INCENTIVE:SUCCESS':
      return {
        ...state,
        customer_photo_incentive_detail: null
      }
    case 'API:FETCH:PROMO:CODE:SELECT:SUCCESS':
      return setPromoCode(state, action)
    case 'API:FETCH:USER:LINKED:SERVICE:SUCCESS':
      return {
        ...state,
        linked_service: {
          ...action.response.data.linked_service
        }
      }
    case 'API:WAITING_LIST:ADD:SUCCESS':
      return {
        ...state,
        ...action.response.data.AddToWaitingList
      }
    case 'API:ONBOARDING:SUBMIT_PARTIAL_STYLE:SUCCESS':
      return {
        ...state,
        style: {
          ...state.style,
          ...action.response.data.UpdateStyle.style
        },
        subscription: {
          ...state.subscription,
          ...action.response.data.UpdateStyle.style.subscription
        }
      }
    case 'API:SHIPPING:ADDRESS:UPDATE:SUCCESS':
      return {
        ...state,
        shipping_address: {
          ...state.shipping_address,
          ...action.response.data.UpdateShippingAddress.shipping_address
        }
      }
    case 'GET:SYLTE:PROFILE:INFO:SUCCESS':
      return {
        ...state,
        style: {
          ...state.style,
          ...action.response.style
        }
      }
    case 'API:BROWSER:SIGN:UP:SUCCESS':
      return {
        ...state,
        ...action.response
      }

    case 'SET:SELECTED:CARD':
      return {
        ...state,
        vacation_card: _.find(state.subscription_types, { id: action.id })
      }
    case 'API:BEACH:VACATION:TYPES:SUCCESS':
      return {
        ...state,
        vacation_card: _.isEmpty(state.vacation_card)
          ? action.response.data.subscription_types[0]
          : state.vacation_card,
        subscription_types: action.response.data.subscription_types
      }
    case 'API:RESTORE:TO:SUSPEND:SUCCESS':
      return {
        ...state,
        subscription: {
          ...state.subscription,
          ...action.response.data.ReactivateSubscription.subscription
        }
      }
    case 'API:FETCH:FLATTEN:PROMO:CODE:SUCCESS':
      return {
        ...state,
        ...action.response.data.me
      }
    case 'API:UPGRADE:SUBSCRIPTION:MIGRATION:SUCCESS':
      return {
        ...state,
        subscription: {
          ...state.subscription,
          ...action.response.data.SubscriptionMigration.subscription
        }
      }
    case 'UPDATE::LIKE::STATE': {
      const {
        customer = {},
        likeCustomerId,
        item: { liked } = {}
      } = action.data
      return handleToggleLike(
        customer,
        likeCustomerId,
        liked ? 1 : -1
      )(state, action)
    }
    case 'API:MY_CUSTOMER_PHOTO_INFO:SUCCESS':
      return getCurrentCustomerPhotoInfo(state, action)
    case 'API:FETCH:SALESMANINFO:SUCCESS':
      return setSalesManInfo(state, action)
    case 'API:CREDIT_ACCOUNT_BANLANCE': {
      const { me } = action.response.data
      return { ...state, ...me }
    }
    case 'API:UPDATE:CUSTOMER_RECALL_INFOMATION:SUCCESS': {
      const { me, recall_topic } = action.response.data
      return { ...state, ...me, recall_topic }
    }
    default:
      return state
  }
}

function handleToggleLike(customer, likeCustomerId, delta) {
  return state => {
    if (toString(customer.id) === likeCustomerId) {
      return {
        ...state,
        customer_photo: {
          ...state.customer_photo,
          liked_count: state.customer_photo.liked_count + delta
        }
      }
    }
    return state
  }
}

function setCurrentCustomer(state, action) {
  if (!action.response || !action.response.data.me) {
    return initialState
  }
  const { me, salesman, web_page_url } = action.response.data
  APPStatisticManager.onUserUpdate(me)
  return {
    ...state,
    isFreeUser:
      me.subscription &&
      me.subscription.promo_code &&
      me.subscription.promo_code.toLowerCase() === 'ltcn_free_tote',
    isFreeTote79:
      me.subscription &&
      me.subscription.promo_code &&
      me.subscription.promo_code.toLowerCase() === 'ltcn_free_tote_79',
    ...me,
    salesman,
    web_page_url
  }
}

function setSalesManInfo(state, action) {
  const { salesman, web_page_url } = action.response.data
  return { ...state, salesman, web_page_url }
}

function setPromoCode(state, action) {
  if (!action.response || !action.response.data.me) {
    return state
  }
  const data = action.response.data
  return {
    ...state,
    ...data.me
  }
}

function querySubscription(state, action) {
  const { me } = action.response.data
  const meData = {
    ...state,
    subscription: { ...state.subscription, ...me.subscription }
  }
  APPStatisticManager.onUserUpdate(meData)
  return meData
}

const getCurrentCustomerPhotoInfo = (state, action) => {
  const me = action.response.data.me
  if (me) {
    return { ...state, customer_photo: me.customer_photo }
  } else {
    return state
  }
}

export default reducer
